/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import "react-toastify/dist/ReactToastify.css";
import {
  setVerifyEmailModal,
  updateUser,
} from "../../../redux/slices/userSlice";
import { useDispatch, useSelector } from "react-redux";
import Success from "../../../components/Toaster/Success";
import StyledMdText from "../../../common/components/styledMdText/StyledMdText";
import GradientButton from "../../../components/Buttons/GradientButton/GradientButton";
import StyledH3Heading from "../../../common/components/styledH3Heading/StyledH3Heading";
import EmailVerificationModal from "../../../components/Modals/EmailVerificationModal/EmailVerificationModal";
import { useUpdateUser } from "../../../Hooks/api/useUpdateUser";
import { useAccount } from "wagmi";
import { useVerifyEmail } from "../../../Hooks/api/useVerifyEmail";
import { useVerifyOtp } from "../../../Hooks/api/useVerifyOtp";
import useCheckUser from "../../../Hooks/api/useCheckUser";
import { useResendOTP } from "../../../Hooks/api/useResendOTP";

const EditProfileSection = () => {
  const dispatch = useDispatch();
  const {
    user,
    email,
    profileImage,
    walletAddress,
    isEmailVerified,
    isVerifyEmailModal,
  } = useSelector((state) => state.user);
  const [username, setUsername] = useState(user);
  const [newEmail, setNewEmail] = useState(email);
  const [emailError, setEmailError] = useState("");
  const [usernameChanged, setUsernameChanged] = useState(false);
  const [imageChanged, setImageChanged] = useState(false);
  const [selectedImage, setSelectedImage] = useState(profileImage);
  const [isEmailVerifiedStatus, setIsEmailVerifiedStatus] =
    useState(isEmailVerified);
  const [code, setCode] = useState("");

  // const [isInstagramConnected, setIsInstagramConnected] = useState(false);
  // const [isTwitterConnected, setIsTwitterConnected] = useState(false);
  // const [twitterUsername, setTwitterUsername] = useState("johndoe12");

  const { mutate } = useUpdateUser();
  const { mutate: mutateOtp, isPending: otpPending } = useVerifyOtp({
    onSuccess: handleOnSuccess,
  });
  const { mutate: mutateEmail, isPending } = useVerifyEmail({
    onSuccess: handleVerifyEmailSuccess,
  });
  const { mutate: checkUser } = useCheckUser();
  const { mutate: resendOTP, isPending: resendPending } = useResendOTP();
  const { address } = useAccount();
  
  // const { data } = useConnectInstagram(walletAddress);
  // const { mutate: disconnectAccount } = useDisconnectAccount();
  // const { data: connectTwitter } = useConnectTwitter(walletAddress);

  function handleOnSuccess() {
    dispatch(
      updateUser({
        user: username,
        email: newEmail,
        profileImage: selectedImage,
        isEmailVerified: isEmailVerifiedStatus,
      })
    );
    dispatch(setVerifyEmailModal(false));
    setIsEmailVerifiedStatus(true);
    checkUser(walletAddress);
  }
  function handleVerifyEmailSuccess() {
    dispatch(
      updateUser({
        user: username,
        profileImage: selectedImage,
      })
    );
  }
  const handleVerifyEmail = () => {
    mutateEmail({
      user_name: username,
      user_email: newEmail,
      profile_image: selectedImage,
      wallet_address: address,
    });
  };

  const handleResendOTP = () => {
    resendOTP({
      user_email: newEmail,
      wallet_address: address,
    });
  };

  const handleVerifyOtp = () => {
    mutateOtp({
      otpCode: code,
      user_email: newEmail,
      wallet_address: address,
    });
  };

  const handleUpdateProfile = () => {
    if (!username || !newEmail) {
      return;
    }
    mutate({
      wallet_address: address,
      user_name: username,
      user_email: newEmail,
      profile_image: selectedImage,
    });
    setUsernameChanged(false);
    setImageChanged(false);
  };

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const imageUrl = reader.result;
        setSelectedImage(imageUrl);
        if (imageUrl !== profileImage) {
          setImageChanged(true);
        }
        if (imageUrl === profileImage) {
          setImageChanged(false);
        }
      };
      reader.readAsDataURL(file);
    }
  };

  const handleEmailChange = (e) => {
    const emailValue = e.target.value;
    setNewEmail(emailValue);
    if (!emailValue) {
      setEmailError("");
    } else if (!emailRegex.test(emailValue)) {
      setEmailError("Please enter a valid email address");
    } else {
      setEmailError("");

      if (emailValue === email && isEmailVerified) {
        setIsEmailVerifiedStatus(true);
      } else {
        setIsEmailVerifiedStatus(false);
      }
    }
  };

  const handleUsernameChange = (e) => {
    const usernameValue = e.target.value;
    setUsername(usernameValue);
    if (user !== usernameValue) {
      setUsernameChanged(true);
    }

    if (user === usernameValue) {
      setUsernameChanged(false);
    }
  };

  const handleCopy = () => {
    navigator?.clipboard?.writeText(walletAddress).then(() => {
      Success({ message: "Text Copied" });
    });
  };

  // Handle Twitter Connect
  // const handleTwitterConnect = () => {
  //   connectTwitter(); // Twitter connect hook that handles redirection
  // };

  // Handle Disconnect Account
  // const handleDisconnectAccount = (account) => {
  //   disconnectAccount({
  //     wallet_address: walletAddress,
  //     account,
  //     onSuccess: () => {
  //       if (account === "instagram") {
  //         setIsInstagramConnected(false);
  //       } else if (account === "twitter") {
  //         setIsTwitterConnected(false);
  //       }
  //     },
  //     onError: () => {
  //       console.error(`Failed to disconnect ${account}`);
  //     },
  //   });
  // };

  const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
  const usernameRegix = /^[a-zA-Z0-9!@#$%^&*()_+={}\[\]:;"'<>,.?/~\\|\s-]+$/;

  const isUserNameValid =
    username.length > 0
      ? usernameRegix.test(username) && username.trim().length > 5
      : true;

  const isValidEmail = emailRegex.test(newEmail) || newEmail !== email;
  const isUpdateValid = usernameChanged || imageChanged;
  const isVerified =
    username.trim() !== "" && emailError.trim() === "" && isValidEmail;

  return (
    <div className="w-full flex justify-center items-center pt-10 min-h-[calc(100vh-190px)] ">
      <div className="w-[90%] md:w-[80%] flex flex-col justify-center items-center gap-10">
        {/* Heading */}
        <div className="flex flex-col gap-1 justify-center items-center text-center">
          <StyledH3Heading fontColor={"text-regular-orange"}>
            Edit Profile
          </StyledH3Heading>
          <StyledMdText fontColor={"lg:w- xl:w-9/12"}>
            Here you can edit your profile details like profile picture, email
            and username
          </StyledMdText>
        </div>

        {/* Edit Profile */}
        <div className="w-full flex flex-col-reverse lg:flex-row justify-center items-center lg:items-start gap-12">
          <div className="w-full lg:w-3/5 xl:w-[50%] flex flex-col gap-5">
            {/* User Profile */}
            <div className="border border-bright-yellow rounded-xl bg-black px-5 md:px-10 pt-12 pb-8 flex flex-col items-center sm:items-start gap-5">
              <div className="relative w-full md:w-[95%] min-w-[200px] h-12">
                <input
                  type="text"
                  className="peer h-[40px] w-full rounded-[7px] border border-bright-yellow border-t-transparent bg-transparent px-3 py-4  !text-md outline outline-0 transition-all placeholder-shown:border placeholder-shown:border-bright-yellow placeholder-shown:border-t-bright-yellow focus:border-1 focus:border-bright-yellow focus:border-t-transparent focus:outline-0 disabled:border-0 disabled:bg-blue-gray-50"
                  placeholder=" "
                  value={username}
                  maxLength={30}
                  onChange={handleUsernameChange}
                />
                {!isUserNameValid && (
                  <p className="text-red-500 text-sm">
                    Minimum 5 characters are required.{" "}
                  </p>
                )}
                <label className="before:content[' '] after:content[' '] pointer-events-none absolute left-0 -top-1.5 flex h-full w-full select-none !overflow-visible truncate text-[11px] font-normal leading-tight text-white transition-all before:pointer-events-none before:mt-[6.5px] before:mr-1 before:box-border before:block before:h-1.5 before:w-2.5 before:rounded-tl-md before:border-t before:border-l before:border-bright-yellow before:transition-all after:pointer-events-none after:mt-[6.5px] after:ml-1 after:box-border after:block after:h-1.5 after:w-2.5 after:flex-grow after:rounded-tr-md after:border-t after:border-r after:border-bright-yellow after:transition-all peer-placeholder-shown:text-sm peer-placeholder-shown:leading-[4.8] peer-placeholder-shown:text-white peer-placeholder-shown:before:border-transparent peer-placeholder-shown:after:border-transparent peer-focus:text-[11px] peer-focus:leading-tight peer-focus:text-white peer-focus:before:border-t-1 peer-focus:before:border-l-1 peer-focus:before:border-bright-yellow peer-focus:after:border-t-1 peer-focus:after:border-r-1 peer-focus:after:border-bright-yellow peer-disabled:text-transparent peer-disabled:before:border-transparent peer-disabled:after:border-transparent peer-disabled:peer-placeholder-shown:text-blue-gray-500">
                  Username
                </label>
              </div>
              <div className="relative w-full md:w-[95%] min-w-[200px] h-12">
                <input
                  type="email"
                  className="peer h-[40px] w-full rounded-[7px] border border-bright-yellow border-t-transparent bg-transparent px-3 py-4 !text-md outline outline-0 transition-all placeholder-shown:border placeholder-shown:border-bright-yellow placeholder-shown:border-t-bright-yellow focus:border-1 focus:border-bright-yellow focus:border-t-transparent focus:outline-0 disabled:border-0 disabled:bg-blue-gray-50"
                  placeholder=" "
                  value={newEmail}
                  onChange={handleEmailChange}
                  maxLength={40}
                />
                {emailError && (
                  <p className="text-red-500 text-sm">{emailError}</p>
                )}
                <label className="before:content[' '] after:content[' '] pointer-events-none absolute left-0 -top-1.5 flex h-full w-full select-none !overflow-visible truncate text-[11px] font-normal leading-tight text-white transition-all before:pointer-events-none before:mt-[6.5px] before:mr-1 before:box-border before:block before:h-1.5 before:w-2.5 before:rounded-tl-md before:border-t before:border-l before:border-bright-yellow before:transition-all after:pointer-events-none after:mt-[6.5px] after:ml-1 after:box-border after:block after:h-1.5 after:w-2.5 after:flex-grow after:rounded-tr-md after:border-t after:border-r after:border-bright-yellow after:transition-all peer-placeholder-shown:text-sm peer-placeholder-shown:leading-[4.8] peer-placeholder-shown:text-white peer-placeholder-shown:before:border-transparent peer-placeholder-shown:after:border-transparent peer-focus:text-[11px] peer-focus:leading-tight peer-focus:text-white peer-focus:before:border-t-1 peer-focus:before:border-l-1 peer-focus:before:border-bright-yellow peer-focus:after:border-t-1 peer-focus:after:border-r-1 peer-focus:after:border-bright-yellow peer-disabled:text-transparent peer-disabled:before:border-transparent peer-disabled:after:border-transparent peer-disabled:peer-placeholder-shown:text-blue-gray-500">
                  Email Address
                </label>
                <div className="text-right text-sm text-gray-400">
                  {isEmailVerifiedStatus ? "Verified" : "Not Verified"}
                </div>
              </div>

              {!isEmailVerifiedStatus && (
                <GradientButton
                  onClick={handleVerifyEmail}
                  fontColor={"!px-5 mt-1"}
                  disabled={!isVerified || isPending || newEmail === ""}
                >
                  Verify Email
                </GradientButton>
              )}

              {isEmailVerifiedStatus && (
                <GradientButton
                  onClick={handleUpdateProfile}
                  fontColor={"!px-5 mt-1"}
                  disabled={
                    !isUpdateValid ||
                    !isValidEmail ||
                    !isUserNameValid ||
                    username.trim() === ""
                  }
                >
                  Update
                </GradientButton>
              )}
            </div>
            <hr className="w-full h-[1px] bg-white opacity-30" />

            {/* User Wallet Address */}
            <div className="w-full flex items-center relative">
              <div className="w-full h-[50px] border border-bright-yellow rounded-md text-md py-2 px-4 flex-grow bg-transparent flex items-center">
                <StyledMdText fontColor={"truncate pr-52"}>
                  {walletAddress}
                </StyledMdText>
              </div>
              <button className="absolute right-3" onClick={handleCopy}>
                <img src="/assets/copy.svg" alt="copy" loading="lazy" />
              </button>
            </div>
            {/* <hr className="w-full h-[1px] bg-white opacity-30" /> */}

            {/* Social */}
            {/* <div className="flex flex-col gap-4">
              <StyledH6Heading>Social Links</StyledH6Heading>
              <StyledMdText>
                Verify your account by connecting social accounts
              </StyledMdText>

              <div className="w-full sm:w-3/5 md:w-[60%] flex flex-col gap-2">
                <div className="flex justify-center items-center gap-2.5">
                  <img src="/assets/instagram.svg" alt="instagram" />

                  <div className="bg-[#252525] rounded-md py-2 pl-2 px-10 flex-grow">
                    <StyledLgText>Instagram</StyledLgText>
                  </div>
                  <div>
                    {isInstagramConnected ? (
                      <div className="flex items-center gap-2">
                        <span>Connected</span>
                        <button
                          onClick={() => handleDisconnectAccount("instagram")}
                          className="rounded-full bg-[#f0f0f0] flex justify-center items-center w-6 h-6"
                        >
                          <img src="/assets/cross-icon.svg" alt="Disconnect" />
                        </button>
                      </div>
                    ) : (
                      <Link to={data} target="__blank">
                        <GradientButton children={"Connect"} />
                      </Link>
                    )}
                  </div>
                </div>
                <div className="flex justify-center items-center gap-2.5">
                  <img src="/assets/twitter.svg" alt="twitter" />
                  <div className="bg-[#252525] rounded-md py-2 pl-2 px-10 flex-grow">
                    {isTwitterConnected ? (
                      <StyledLgText>{twitterUsername}</StyledLgText>
                    ) : (
                      <StyledLgText>Twitter</StyledLgText>
                    )}
                  </div>
                  <div>
                    {isTwitterConnected ? (
                      <div className="flex items-center gap-2">
                        <button
                          onClick={() => handleDisconnectAccount("twitter")}
                          className="rounded-full bg-[#f0f0f0] flex justify-center items-center w-6 h-6"
                        >
                          <img src="/assets/cross-icon.svg" alt="Disconnect" />
                        </button>
                      </div>
                    ) : (
                    <Link to={connectTwitter} target="_blank">  
                    <GradientButton children={"Connect"} />
                    </Link>
                    )}
                  </div>
                </div>
              </div>
            </div> */}
          </div>

          {/* Sidebar */}
          <aside className="min-w-[20%]">
            {/* Profile Image */}
            <div className="bg-[#303030] drop-shadow-[2px 5px 8px 0px] border border-regular-orange rounded-[27px] p-10">
              <div className="relative flex justify-center">
                <img
                  src={selectedImage || "/assets/upload-image.svg"}
                  alt="Profile"
                  className="border-2 border-bright-yellow rounded-full p-1 h-36 w-36 object-cover"
                />
                <input
                  id="image-upload"
                  type="file"
                  accept="image/*"
                  onChange={handleImageChange}
                  className="hidden"
                />
                <label
                  htmlFor="image-upload"
                  className="cursor-pointer absolute -bottom-[15%] right-[33%]"
                >
                  <img
                    src="/assets/edit-profile-pencil.svg"
                    alt="Edit Profile"
                  />
                </label>
              </div>
            </div>
          </aside>
        </div>
      </div>

      {isVerifyEmailModal && (
        <EmailVerificationModal
          handleVerifyOtp={handleVerifyOtp}
          code={code}
          setCode={setCode}
          closeModal={() => dispatch(setVerifyEmailModal(false))}
          isPending={otpPending}
          onResend={handleResendOTP}
        />
      )}
    </div>
  );
};

export default EditProfileSection;
